import { render } from "./batch_form.vue?vue&type=template&id=3d2b30d0&lang=pug"
import script from "./batch_form.vue?vue&type=script&lang=js"
export * from "./batch_form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__